import { KeyImage } from '@/api';
import { useKeyImageLabelsStore } from '@/store';

export function useActiveKeyImages(renderedSummaryUuid?: string): KeyImage[] {
  const keyImageLabels = useKeyImageLabelsStore((state) => state.keyImageLabels);

  const activeLabels = keyImageLabels
    .filter((label) => label.status !== 'deprecated')
    .filter((label, index, self) => index === self.findIndex((l) => l.uuid === label.uuid));

  return renderedSummaryUuid
    ? activeLabels.filter((label) => label.renderedSummaryUuid === renderedSummaryUuid)
    : activeLabels;
}
